import { get } from 'lodash';
import { getSetting } from '@utils/helpers';
import logger from '@gral/log';
const log = logger('i18n');

export default function detect() {
  let lng = 'en';
  const settingLng = get(getSetting('defaultLanguage'), 'defaultLanguage');
  if (settingLng) {
    lng = settingLng;
    log.info(`Language detected in settings: ${lng}`);
  } else {
    // browser
    const browserLng = navigator.language;
    if (browserLng) {
      const parsed = browserLng.split('-');
      log.info(`Language detected in browser: ${parsed[0]}`);
      if (parsed[0]) lng = parsed[0];
    }
  }
  return lng;
}
